'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './voter-group-show.routes';

const moment = require('moment');

export class VoterGroupShowComponent {
  constructor(Auth, PropertyService, WebAccessService, dialogs, $scope, $uibModal,
              DTOptionsBuilder, DTDefaultOptions, DTState, SettingsService, $stateParams,
              VoterGroupsService, $window, $timeout) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.$timeout = $timeout;

    this.id = $stateParams.id;
    this.PropertyService = PropertyService;
    this.WebAccessService = WebAccessService;
    this.VoterGroupsService = VoterGroupsService;
    this.filteredData = [];
    this.data = [];

    this.dialogs = dialogs;

    this.isCollapsed = true;

    this.chartData = {
      'dist': [],
      'asn': [[],[],[]]
    };
    this.chartLabels = {
      'dist': ["E-Voter","Blocked","Paper Voter"],
      'asn': []
    };
    this.chartColors = {
      'dist': ['#2ECC71','#C70039','#00008b'],
      'asn':  ['#2ECC71','#C70039','#00008b']
    };

    this.chartSeries = {
      'asn': ["E-Voter","Blocked","Paper Voter"]
    };

    this.chartOptions = {
      'dist': {
        legend: {
          display: true,
          position: 'bottom'
        },
        title: {
          display: true,
          text: 'Voting Preference Distribution'
        },
        animation: false
      },
      'asn': {
        title: {
          display: true,
          text: 'Voting Preference Distribution per Association'
        },
        animation: false,
        plugins: {
          stacked100: { enable: true }
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
    };

    SettingsService.getByName({name: 'client'}, settings => {
      this.optInOutRequired = settings.data.optInOut && settings.data.optInOut.required;
      if (this.optInOutRequired) {
        this.optInOutSettings = settings.data.optInOut;
      }

      this.weightVisible = settings.data.weightVisible;
      this.hasBuildingNo = settings.data.buildingNoVisible;
      this.voterGroupEmail = settings.data.voterGroupEmail;

      let schemaName = (this.weightVisible) ? "evoting" : "evoting-no-weight";
      this.eVotingSchema = require('../../../components/schemas/' + schemaName + ".json");

      this.templateAddressLabels = settings.data.templateAddressLabels;
      this.templateCoverLetter = settings.data.templateCoverLetter;

      this.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('dom', 'lBfrtip')
        .withOption('order', (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc'])
        .withOption('deferRender', true)
        .withOption('initComplete', _=> {this.initComplete = true})
        .withOption('stateSave',true)
        .withOption('stateSaveCallback', DTState.save())
        .withOption('stateLoadCallback', DTState.restore())
        .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
        .withOption('columnDefs', [ { className: "col-sep", "targets": [ (this.hasBuildingNo) ? 3 : 2 ] } ])
        .withOption('buttons',[{
          extend: 'excel',
          title: "Voters"
        },{
          extend: 'csv',
          title: "Voters"
        },{
          title: "Voters",
          message: 'As of ' + moment().format("MMMM Do YYYY"),
          extend: 'pdf',
          orientation: 'portrait',
          pageSize: 'LETTER'
        },{
          extend: 'print',
          title: "Voters"
        }]);
    });

    DTDefaultOptions.setLoadingTemplate( '<datatable-loading-placeholder columns="Cmty, Lot#, Address, Primary Owner, Other Owner, Active Tenant" />');

    this.refreshData();
  }

  filterData() {
    this.filteredData = this.data;
    this.rawFilteredData = angular.copy(this.filteredData);
  }

  openReportFilterModal(report) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'reportFilterModal',
      resolve: {
        config: function() {
          return report
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );

  }

  printLabels() {
    this.openReportFilterModal({
      report: 'voter-group-labels-paper-voter',
      template: this.templateAddressLabels,
      voterGroupId: this.id,
      title: 'Address Labels for Paper Voters',
      icon: 'th'
    })
  }

  printLetters() {
    this.openReportFilterModal({
      report: 'voter-group-cover-letter-paper-voter',
      template: this.templateCoverLetter,
      voterGroupId: this.id,
      title: 'Cover Letter for Paper Voters',
      icon: 'file-text-o'
    })
  }

  getCount(option) {

    switch (option) {
      case 'all':
        return this.rawFilteredData.length;
      case 'evoter':
        return this.rawFilteredData.filter(ppty => ppty.eVoting && ppty.eVoting.voter && !ppty.eVoting.blocked && ppty.eVoting.voter.customFields && ppty.eVoting.voter.customFields.eVotingConsent).length;
      case 'papervoter':
        return this.rawFilteredData.filter(ppty => ppty.eVoting && ppty.eVoting.voter && !ppty.eVoting.blocked && (!ppty.eVoting.voter.customFields || !ppty.eVoting.voter.customFields.eVotingConsent)).length;
      case 'blocked':
        return this.rawFilteredData.filter(ppty => ppty.eVoting && ppty.eVoting.voter && ppty.eVoting.blocked).length;
      case 'novoter':
        return this.rawFilteredData.filter(ppty => !ppty.eVoting || !ppty.eVoting.voter).length;
      case 'nowebaccess':
        return this.rawFilteredData.filter(ppty => ppty.eVoting && ppty.eVoting.voter && ppty.eVoting.voter.customFields && ppty.eVoting.voter.customFields.eVotingConsent && !ppty.hasWebAccessVoter).length;
      case 'contactnoweb':
        return this.rawFilteredData.filter(contact => !contact.hasWebAccess).length;
    }
  }

  setFilter(option) {

    switch (option) {
      case 'all':
        this.filter = null;
        this.filterData();
        break;
      case 'evoter':
        this.filter = option;
        this.filterData();
        this.filteredData = this.filteredData.filter(ppty => ppty.eVoting && ppty.eVoting.voter && !ppty.eVoting.blocked && ppty.eVoting.voter.customFields && ppty.eVoting.voter.customFields.eVotingConsent);
        break;
      case  'papervoter':
        this.filter = option;
        this.filterData();
        this.filteredData = this.filteredData.filter(ppty => ppty.eVoting && ppty.eVoting.voter && !ppty.eVoting.blocked && (!ppty.eVoting.voter.customFields || !ppty.eVoting.voter.customFields.eVotingConsent));
        break;
      case 'blocked':
        this.filter = option;
        this.filterData();
        this.filteredData = this.filteredData.filter(ppty => ppty.eVoting && ppty.eVoting.voter && ppty.eVoting.blocked);
        break;
      case 'novoter':
        this.filter = option;
        this.filterData();
        this.filteredData = this.filteredData.filter(ppty => !ppty.eVoting || !ppty.eVoting.voter);
        break;
      case 'nowebaccess':
        this.filter = option;
        this.filterData();
        this.filteredData = this.filteredData.filter(ppty => ppty.eVoting && ppty.eVoting.voter && ppty.eVoting.voter.customFields && ppty.eVoting.voter.customFields.eVotingConsent && !ppty.hasWebAccessVoter);
        break;
      case 'contactnoweb':
        this.filter = option;
        this.filterData();
        this.filteredData = this.filteredData.filter(contact => !contact.hasWebAccess);
    }

  }

  refreshData() {
    this.VoterGroupsService.getWithData({id: this.id}, group => {
      this.group = group;

      //this.PropertyService.query((data) => {
      //  this.data = data;

      if (group.type == 'properties') {
          this.data = group.properties;
      } else {
          this.data = group.contacts;
      }

        this.filterData();

        this.WebAccessService.query((data) => {
          this.webAccesses = data;

          /* if ppty */
          this.data.forEach(ppty => {
            ppty.hasWebAccessVoter = (ppty.eVoting && ppty.eVoting.voter) ? this.hasWebAccess(ppty.eVoting.voter) : false;

            if (ppty.hasWebAccessVoter) {
              ppty.webAccessEmail = this.getWebAccessEmail(ppty.eVoting.voter)
            }
          });

          /* if contact */
          this.data.forEach(contact => {
            contact.hasWebAccess = this.hasWebAccess(contact);

            if (contact.hasWebAccess) {
              contact.webAccessEmail = this.getWebAccessEmail(contact)
            }
          });

          this.chartData = {
            'dist': [],
            'asn': [[],[],[]]
          };
          this.chartLabels = {
            'dist': ["E-Voter","Blocked","Paper Voter"],
            'asn': []
          };

          this.chartData.dist.push(this.getCount("evoter"));
          this.chartData.dist.push(this.getCount("blocked"));
          this.chartData.dist.push(this.getCount("papervoter"));

          this.dataInitComplete = true;

          let asnDistChart = {};

          this.data.forEach(ppty => {
            let key = "Community";
            if (!asnDistChart[key]) {
              asnDistChart[key] = {
                evoter: 0,
                blocked: 0,
                papervoter: 0
              };
            }

            if (ppty.eVoting && ppty.eVoting.voter && !ppty.eVoting.blocked && ppty.eVoting.voter.customFields && ppty.eVoting.voter.customFields.eVotingConsent) {
              asnDistChart[key].evoter++;
            } else if (ppty.eVoting && ppty.eVoting.voter && !ppty.eVoting.blocked && (!ppty.eVoting.voter.customFields || !ppty.eVoting.voter.customFields.eVotingConsent)) {
              asnDistChart[key].papervoter++;
            } else if (ppty.eVoting && ppty.eVoting.voter && ppty.eVoting.blocked) {
              asnDistChart[key].blocked++;
            }
          });

          Object.keys(asnDistChart).forEach(code => {
            this.chartLabels['asn'].push(code);
            this.chartData['asn'][0].push(asnDistChart[code].evoter);
            this.chartData['asn'][1].push(asnDistChart[code].blocked);
            this.chartData['asn'][2].push(asnDistChart[code].papervoter);
          });

        }, err => {
          console.log("Could not retrieve website access.")
        });

      }, err => {
        console.log("Could not retrieve properties.")
      });
    //})

  }

  openEFormResultModal(eFormResultId) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'eFormResultModal',
      resolve: {
        config: function(){
          return {
            eFormId: that.optInOutSettings.optInForm,
            eFormResultId: eFormResultId
          }
        }
      }
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );
  }

  editVoting(property) {
    var that = this;

    let eVoting = {};
    if (property.eVoting && property.eVoting.voter) {
      eVoting = angular.copy(property.eVoting);
      eVoting.voter = eVoting.voter._id;
    }

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'schemaFormModal',
      resolve: {
        config: function() {
          return {
            title: "Voting",
            icon: "check-square-o",
            model: eVoting,
            schema: that.eVotingSchema,
            dependsOn: ["contacts"]
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (editedEVoting) {
        property.eVoting = editedEVoting;

        that.PropertyService.update({id: property._id}, property, _ => {
          that.refreshData();
        }, err => {
          console.log('could not edit contacts of property');
        });
      },
      function () { /* cancel */ }
    );
  }

  hasWebAccess(voter) {
    return !!this.webAccesses.find(wa => wa.contact && wa.contact._id && wa.contact._id == voter._id);
  }

  getWebAccessEmail(voter) {
    if (!this.hasWebAccess(voter))
      return "-";

    let wa = this.webAccesses.find(wa => wa.contact && wa.contact._id && wa.contact._id == voter._id);

    return wa.email;
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "") {
        composedName += contact.company;
      } else {
        composedName += "<br/>" + contact.company;
      }
    }

    return composedName;
  }

  getAddress(property) {
    try {
      let address = property.address.street;

      if (property.address.city && property.address.state && property.address.zip) {
        address += `, ${property.address.city} ${property.address.state}, ${property.address.zip}`;
      } else if (property.address.city) {
        address += `, ${property.address.city}`;
      } else if (property.address.state && property.address.zip) {
        address += `, ${property.address.state}, ${property.address.zip}`;
      }

      return address;
    } catch (e){
      return "-";
    }
  }

  getPrimaryOwnerId(contacts) {
    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary) // No Primary Owner
      return 0;
    else if (!primary.contact || !primary.contact._id) // Contact for Primary Owner deleted
      return -1;
    else
      return primary.contact._id;
  }

  getOtherOwnerId(contacts) {
    let other = contacts.find(contact => contact.type == 'owner');

    if (!other) // No Other Owner
      return 0;
    else if (!other.contact || !other.contact._id) // Contact for Other Owner deleted
      return -1;
    else
      return other.contact._id;
  }

  getActiveTenantId(contacts) {
    let activeTenant = contacts.find(contact => {
      try {
        if (contact.type == 'renter') {

          if (!contact.from && !contact.till) // if no dates are defined, we assume thatt the renter should be the current one
            return true;

          if (contact.from && contact.till) {
            return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
          }

          if (!contact.from && contact.till) {
            return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
          }

          if (contact.from && !contact.till) {
            return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
          }
        } else {
          return false;
        }

      } catch(e) {
        console.log(e);
        return false;
      }
    });

    if (!activeTenant) // No Other Owner
      return 0;
    else if (!activeTenant.contact || !activeTenant.contact._id) // Contact for Other Owner deleted
      return -1;
    else
      return activeTenant.contact._id;
  }

  getPrimaryOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return "-";

    return this.getComposedName(primary.contact);
  }

  getPrimaryOwnerEmail(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return "-";

    let email = primary.contact.email.find(e => e.isPrimary);

    if (!email)
      return "-";

    return email.address;
  }

  getOtherOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let other = contacts.find(contact => contact.type == 'owner');

    if (!other)
      return "-";

    return this.getComposedName(other.contact);
  }

  getActiveTenant(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let activeTenant = contacts.find(contact => {
      try {
        if (contact.type == 'renter') {

          if (!contact.from && !contact.till) // if no dates are defined, we assume thatt the renter should be the current one
            return true;

          if (contact.from && contact.till) {
            return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
          }

          if (!contact.from && contact.till) {
            return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
          }

          if (contact.from && !contact.till) {
            return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
          }
        } else {
          return false;
        }

      } catch(e) {
        console.log(e);
        return false;
      }
    });

    if (!activeTenant)
      return "-";

    return this.getComposedName(activeTenant.contact);
  }

}

export default angular.module('conduu.voterGroupShow', [uiRouter])
  .config(routes)
  .component('voterGroupShow', {
    template: require('./voter-group-show.html'),
    controller: VoterGroupShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/voter-group/voter-group-show/voter-group-show.component.js